import { render } from "./SetupFollowScheduleModal.vue?vue&type=template&id=585fba74&scoped=true"
import script from "./SetupFollowScheduleModal.vue?vue&type=script&lang=js"
export * from "./SetupFollowScheduleModal.vue?vue&type=script&lang=js"

import "./SetupFollowScheduleModal.vue?vue&type=style&index=0&id=585fba74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585fba74"]])

export default __exports__